export const fontSizes = {
  xxl: '4rem',
  xl: '2rem',
  l: '1.5rem',
  m: '1.2rem',
  r: '1rem',
  s: '0.8rem',
};
export const fontFamily = '-apple-system, BlinkMacSystemFont, \'Segoe UI\', \'Roboto\', \'Oxygen\', \'Ubuntu\', \'Cantarell\', \'Fira Sans\', \'Droid Sans\', \'Helvetica Neue\', sans-serif';
